<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Accounting-Codes") }} </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-flex xs12 sm3 md5 mr-5 v-if="!viewType">
              <v-text-field
                flat=""
                prepend-inner-icon="live_help"
                v-model="searchData.SearchText"
                solo-inverted=""
                hide-details
                :label="$t('Search')"
                @click:append="getListPageZero()"
                append-icon="search"
                @keyup.enter="getListPageZero()"
              >
                <v-tooltip slot="prepend-inner" bottom>
                  <v-icon slot="activator" color="primary" dark
                    >live_help</v-icon
                  >
                </v-tooltip>
              </v-text-field>
            </v-flex>

            <v-tooltip bottom>
              <v-btn
                :disabled="!sayfayetki.Save"
                slot="activator"
                @click="gitAdd()"
                flat
              >
                <span class="hidden-sm-and-down"> {{ $t("Add") }} </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span v-if="!sayfayetki.Save">{{
                $t("Limited-Authorization")
              }}</span>
              <span v-if="sayfayetki.Save">{{ $t("Add") }}</span>
            </v-tooltip>

            <v-menu offset-y v-if="!viewType">
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <!-- Sıralama ve Filtreleme -->
        <v-flex xs12 sm12 md12>
          <v-card width="100%" flat color="grey lighten-5" class="pl-3 pr-3">
            <v-layout row wrap align-center>
              <v-flex
                xs12
                sm12
                md9
                class="headline font-weight-regular pl-3 grey--text"
              >
                {{ totalCountText }}
              </v-flex>
              <v-flex xs12 sm12 md2 pt-2>
                <v-select
                  :label="$t('Sort-By')"
                  :items="siralamaItems"
                  v-model="searchData.Paging.OrderType"
                  item-text="Text"
                  item-value="Value"
                  @change="getListPageZero()"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm12 md1 pt-2>
                <v-select
                  :label="this.$t('Show')"
                  :items="veriItem"
                  v-model="searchData.Paging.DataCount"
                  item-text="Text"
                  item-value="Value"
                  @change="getListPageZero()"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 sm12 md12 pt-2 v-if="!viewType">
          <v-container fluid grid-list-sm>
            <v-flex>
              <v-data-table
                :rows-per-page-items="[100]"
                :headers="headersCardItems"
                :items="cardItems"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="text-xs-left">
                      {{ props.item.Code }}
                    </td>
                    <td class="text-xs-left">
                      {{ props.item.CodeName }}
                    </td>
                    <td class="text-xs-right">
                      <v-btn
                        color="info"
                        @click="gitUpdate(props.item)"
                        outline
                        fab
                        small
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- sayfalama -->
    <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                color="info"
                v-model="searchData.Paging.PageNo"
                :length="pagenumber"
                :total-visible="6"
                @input="getListItems()"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "@/api/auth";

export default {
  data() {
    return {
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: "Koda Göre Azalan",
          Value: 1,
        },
        {
          Text: "Koda Göre Artan",
          Value: 0,
        },
        {
          Text: "Kod Adına Göre Artan",
          Value: 2,
        },
        {
          Text: "Kod Adına Göre Azalan",
          Value: 3,
        },
      ],
      totalCountText: null,
      pagenumber: 0,
      vmodelpagination: false,
      accoutingCode: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        MainCodeInfo: {
          CodeID: 0,
          CompanyID: 0,
          Code: null,
          CodeName: null,
        },
        Code: null,
        CodeName: null,
        AccountGroup: null,
        AccountCodeInfo: {
          SirketKodu: 0,
          Kod: null,
          Unvan: null,
          Unvani2: null,
          MuhasebeKodu: null,
          VergiDaire: null,
          VergiNo: null,
          TCNo: null,
        },
        ForeignCurrencyCode: false,
        Currency: null,
        BalanceType: 0, //0 : tüm 1: alacak 2:borç
        CodeActivePassive: false,
        ActivePassiveDate: null,
        ActivePassiveUserID: 0,
        CodeLocked: false,
        LockedDate: null,
        LockedUserID: 0,
        AlternativeCode: null,
        AlternativeCodeName: null,
        ReferanceForced: false,
        CostCenterForced: false,
        RootCode: false,
        SectionCodeForced: false,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: null,
        LogList: [],
      },
      headersCardItems: [
        {
          text: "Kod",
          value: "Code",
        },
        {
          text: "Kod Adı",
          value: "CodeName",
        },
        {
          text: "İşlem",
          align: "right",
        },
      ],
      cardItems: [],
      codes: [],
      active: [],
      avatar: null,
      open: [],
      users: [],
      viewType: false, //false: Treeview true: cardView
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: true,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      searchData: {
        UserID: 0,
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        SearchText: null,
        Paging: {
          PageNo: 1,
          DataCount: 100,
          OrderType: 0,
        },
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
    };
  },
  methods: {
    gitAdd() {
      var url = "#/muhasebe/muhasebekodlari/islem/id?islem=new";
      window.open(url, "_blank");
    },
    getListPageZero() {
      this.searchData.Paging.PageNo = 1;
      this.getListItems();
    },
    getListExcel() {
      var params = {
        CodeID: null,
        CompanyID: this.credentials.MuhasebeSirketNo,
        Code: null,
        CodeName: null,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeListExcel",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeKodListesi.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-MuhasebeKodlariExcel";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-MuhasebeKodlariExcel";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getListHtml() {
      this.loadingvmodel = true;
      var params = {
        CodeID: null,
        CompanyID: this.credentials.MuhasebeSirketNo,
        Code: null,
        CodeName: null,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeListHtml",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/html",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeKodListesi.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-MuhasebeKodlariHTML";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-MuhasebeKodlariHTML";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    gitUpdate(val) {
      var url =
        "#/muhasebe/muhasebekodlari/islem/id?" +
        "islem=get&Code=" +
        val.Code +
        "&CompanyID=" +
        val.CompanyID +
        "&CodeID=" +
        val.CodeID;
      window.open(url, "_blank");
    },
    fetchAccount(item) {
      this.loadingvmodel = true;
      var params = {
        UserID: this.credentials.UserID,
        CompanyID: this.credentials.MuhasebeSirketNo,
        CodeID: item.id,
        Code: item.code,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingCodes/AccountingCodeLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.accoutingCode = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getListItems() {
      this.loadingvmodel = true;
      this.searchData.CompanyID = this.credentials.MuhasebeSirketNo;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountingCodeList",
          this.searchData,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.cardItems = response.body;
            this.loadingvmodel = false;
            if (this.cardItems.length > 0) {
              this.pagenumber = response.body[0].TotalPage;
              this.totalCountText =
                response.body[0].TotalCount + this.$t("number-records-listed");
            } else {
              this.pagenumber = 1;
              this.totalCountText = null;
            }
            this.pagenumber > 1
              ? (this.vmodelpagination = true)
              : (this.vmodelpagination = false);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-AccountingCodeList";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {

    this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
       
       
      
       if (this.sayfayetki.Status == true) {
        this.loadingvmodel = true;
        this.getListItems();
       }
       else
       {
        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

if (sonuc == true) {

    if (this.prevRoute != null) {
        var url = '#' + this.prevRoute

        window.open(url, '_self')
    } else {
        var url = '#/'
        window.open(url, '_self')
    }
} else {

}

});
       }
    
    // var params = {
    //   CodeID: null,
    //   CompanyID: this.credentials.MuhasebeSirketNo,
    //   Code: null,
    //   CodeName: null,
    // };
    // this.$http
    //   .post(
    //     auth.API_URL + "api/AccountingCodes/AccountingCodeTreeList",
    //     params,
    //     {
    //       headers: {
    //         Authorization: "Bearer " + auth.getAuthHeader(),
    //       },
    //     }
    //   )
    //   .then(
    // (response) => {
    //   for (let index = 0; index < response.body.length; index++) {
    //     const element = response.body[index];
    //     //Ana Hesaplar Listeleniyor
    //     if (element.MainCodeID == 0) {
    //       var mainParams = {
    //         id: element.CodeID,
    //         name: element.Code + " - " + element.CodeName,
    //         level: element.Level,
    //         code: element.Code,
    //         maincode: element.MainCodeID,
    //         children: [],
    //       };
    //       this.codes.push(mainParams);
    //     }
    //   }

    //   for (let index = 0; index < response.body.length; index++) {
    //     const element = response.body[index];
    //     //Alt Hesaplar Listeleniyor

    //     var childParams = {
    //       id: element.CodeID,
    //       name:
    //         element.Code + " - " + element.CodeName,
    //       level: element.Level,
    //       code: element.Code,
    //       maincode: element.MainCodeID,
    //       children: [],
    //     };

    //     for (let i = 0; i < this.codes.length; i++) {
    //       //Level 2
    //       if (element.Level == 2) {
    //         let searchMainList = this.codes.findIndex(
    //           (z) => z.id == childParams.maincode
    //         );
    //         if (searchMainList != -1) {
    //           let controlValue = this.codes[
    //             searchMainList
    //           ].children.findIndex((t) => t.id == childParams.id);

    //           if (controlValue == -1) {
    //             this.codes[searchMainList].children.push(childParams);
    //           }
    //         }
    //       }

    //       for (let j = 0; j < this.codes[i].children.length; j++) {
    //         //Level 3
    //         if (element.Level == 3) {
    //           let searchMainList = this.codes[i].children.findIndex(
    //             (z) => z.id == childParams.maincode
    //           );
    //           if (searchMainList != -1) {
    //             let controlValue = this.codes[i].children[
    //               searchMainList
    //             ].children.findIndex((t) => t.id == childParams.id);

    //             if (controlValue == -1) {
    //               this.codes[i].children[searchMainList].children.push(
    //                 childParams
    //               );
    //             }
    //           }
    //         }

    //         for (
    //           let k = 0;
    //           k < this.codes[i].children[j].children.length;
    //           k++
    //         ) {
    //           //Level 4
    //           if (element.Level == 4) {
    //             var searchMainListLevel4;
    //             var controlValueLevel4;
    //             if (this.codes[i].children[j].children.length > 0) {
    //               searchMainListLevel4 = this.codes[i].children[
    //                 j
    //               ].children.findIndex((z) => z.id == childParams.maincode);

    //               if (searchMainListLevel4 != -1) {
    //                 controlValueLevel4 = this.codes[i].children[j].children[
    //                   searchMainListLevel4
    //                 ].children.findIndex((t) => t.id == childParams.id);

    //                 if (controlValueLevel4 == -1) {
    //                   this.codes[i].children[j].children[
    //                     searchMainListLevel4
    //                   ].children.push(childParams);
    //                 }
    //               }
    //             }
    //           }

    //           for (
    //             let l = 0;
    //             l < this.codes[i].children[j].children[k].children.length;
    //             l++
    //           ) {
    //             //Level 5
    //             if (element.Level == 5) {
    //               let searchMainList = this.codes[i].children[j].children[
    //                 k
    //               ].children.findIndex((z) => z.id == childParams.maincode);
    //               if (searchMainList != -1) {
    //                 let controlValue = this.codes[i].children[j].children[
    //                   k
    //                 ].children[searchMainList].children.findIndex(
    //                   (t) => t.id == childParams.id
    //                 );

    //                 if (controlValue == -1) {
    //                   this.codes[i].children[j].children[k].children[
    //                     searchMainList
    //                   ].children.push(childParams);
    //                 }
    //               }
    //             }

    // for (
    //   let m = 0;
    //   m <
    //   this.codes[i].children[j].children[k].children[l].children
    //     .length;
    //   m++
    // ) {
    //   //Level 6

    //   if (element.Level == 6) {
    //     let searchMainList = this.codes[i].children[j].children[
    //       k
    //     ].children[l].children.findIndex(
    //       (z) => z.id == childParams.maincode
    //     );

    //     if (searchMainList != -1) {
    //       let controlValue = this.codes[i].children[j].children[
    //         k
    //       ].children[l].children[
    //         searchMainList
    //       ].children.findIndex((t) => t.id == childParams.id);

    //       if (controlValue == -1) {
    //         this.codes[i].children[j].children[k].children[
    //           l
    //         ].children[searchMainList].children.push(
    //           childParams
    //         );
    //       }
    //     }
    //   }

    //   // for (
    //   //   let n = 0;
    //   //   n <
    //   //   this.codes[i].children[j].children[k].children[l]
    //   //     .children[m].children.length;
    //   //   n++
    //   // ) {
    //   //   //Level 7
    //   //   console.log("LEVEL 7");

    //   //   if (element.Level == 7) {
    //   //     let searchMainList = this.codes[i].children[
    //   //       j
    //   //     ].children[k].children[l].children[
    //   //       m
    //   //     ].children.findIndex(
    //   //       (z) => z.id == childParams.maincode
    //   //     );

    //   //     if (searchMainList != -1) {
    //   //       let controlValue = this.codes[i].children[
    //   //         j
    //   //       ].children[k].children[l].children[m].children[
    //   //         searchMainList
    //   //       ].children.findIndex((t) => t.id == childParams.id);

    //   //       if (controlValue == -1) {
    //   //         this.codes[i].children[j].children[k].children[
    //   //           l
    //   //         ].children[m].children[
    //   //           searchMainList
    //   //         ].children.push(childParams);
    //   //       }
    //   //     }
    //   //   }
    //   //   for (
    //   //     let p = 0;
    //   //     p <
    //   //     this.codes[i].children[j].children[k].children[l]
    //   //       .children[m].children[n].children.length;
    //   //     p++
    //   //   ) {
    //   //     //Level 8

    //   //     if (element.Level == 8) {
    //   //       let searchMainList = this.codes[i].children[
    //   //         j
    //   //       ].children[k].children[l].children[m].children[
    //   //         p
    //   //       ].children.findIndex(
    //   //         (z) => z.id == childParams.maincode
    //   //       );

    //   //       if (searchMainList != -1) {
    //   //         let controlValue = this.codes[i].children[
    //   //           j
    //   //         ].children[k].children[l].children[m].children[
    //   //           p
    //   //         ].children[searchMainList].children.findIndex(
    //   //           (t) => t.id == childParams.id
    //   //         );

    //   //         if (controlValue == -1) {
    //   //           this.codes[i].children[j].children[k].children[
    //   //             l
    //   //           ].children[m].children[p].children[
    //   //             searchMainList
    //   //           ].children.push(childParams);
    //   //         }
    //   //       }
    //   //     }

    //   //     for (
    //   //       let r = 0;
    //   //       r <
    //   //       this.codes[i].children[j].children[k].children[l]
    //   //         .children[m].children[n].children[p].children
    //   //         .length;
    //   //       r++
    //   //     ) {
    //   //       //Level 9

    //   //       if (element.Level == 9) {
    //   //         let searchMainList = this.codes[i].children[
    //   //           j
    //   //         ].children[k].children[l].children[m].children[
    //   //           p
    //   //         ].children[r].children.findIndex(
    //   //           (z) => z.id == childParams.maincode
    //   //         );

    //   //         if (searchMainList != -1) {
    //   //           let controlValue = this.codes[i].children[
    //   //             j
    //   //           ].children[k].children[l].children[m].children[
    //   //             p
    //   //           ].children[r].children[
    //   //             searchMainList
    //   //           ].children.findIndex(
    //   //             (t) => t.id == childParams.id
    //   //           );

    //   //           if (controlValue == -1) {
    //   //             this.codes[i].children[j].children[
    //   //               k
    //   //             ].children[l].children[m].children[
    //   //               p
    //   //             ].children[r].children[
    //   //               searchMainList
    //   //             ].children.push(childParams);
    //   //           }
    //   //         }
    //   //       }

    //   //       for (
    //   //         let s = 0;
    //   //         s <
    //   //         this.codes[i].children[j].children[k].children[l]
    //   //           .children[m].children[n].children[p].children[r]
    //   //           .children.length;
    //   //         s++
    //   //       ) {
    //   //         //Level 10

    //   //         if (element.Level == 10) {
    //   //           let searchMainList = this.codes[i].children[
    //   //             j
    //   //           ].children[k].children[l].children[m].children[
    //   //             p
    //   //           ].children[r].children[s].children.findIndex(
    //   //             (z) => z.id == childParams.maincode
    //   //           );

    //   //           if (searchMainList != -1) {
    //   //             let controlValue = this.codes[i].children[
    //   //               j
    //   //             ].children[k].children[l].children[
    //   //               m
    //   //             ].children[p].children[r].children[
    //   //               s
    //   //             ].children[searchMainList].children.findIndex(
    //   //               (t) => t.id == childParams.id
    //   //             );

    //   //             if (controlValue == -1) {
    //   //               this.codes[i].children[j].children[
    //   //                 k
    //   //               ].children[l].children[m].children[
    //   //                 p
    //   //               ].children[r].children[s].children[
    //   //                 searchMainList
    //   //               ].children.push(childParams);
    //   //             }
    //   //           }
    //   //         }
    //   //       }
    //   //     }
    //   //   }
    //   //}
    // }
    //         }
    //       }
    //     }
    //   }

    // }
    //     this.loadingvmodel = false;
    //   },
    //   (response) => {
    //     if (response.status === 0) {
    //       this.text1 = "Service Unavailable-AccountingCodeTreeList";
    //       this.snackbar = true;
    //       this.loadingvmodel = false;
    //     } else {
    //       this.text1 = "Service Unavailable-AccountingCodeTreeList";
    //       this.snackbar = true;
    //       this.loadingvmodel = false;
    //     }
    //   }
    // );
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var url = "#/";
    //           window.open(url, "_self");
    //         }
    //       } else {
    //       }
    //     });
    // }
  },
  watch: {
    viewType: function (val) {
      if (!val && this.cardItems.length == 0) {
        //Card Yapısı Çekiliyor
        this.getListItems();
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style>
</style>

